import React from 'react';
import {long_reads} from './list';
import LongReadsList from './LongReadsList';

export default function AllLongReads(props) {
  return <div className="all-long-reads">
    <LongReadsList list={long_reads} />
  </div>;
};
